import { Core } from "@faire/slate/foundation/color";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { Arrow } from "@faire/web/slate/icons/foundation/Arrow";
import { Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { Link } from "@faire/web/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";

export interface CTATileData {
  text: React.ReactNode;
  linkTo: string;
  onClick?: () => void;
  alwaysVisible?: boolean;
}

export const maybeAddCTATile = <T,>(
  arr: ReadonlyArray<T>,
  data: CTATileData | undefined,
  itemsPerSlide: number
) => {
  if (shouldAddCTATile(arr, data, itemsPerSlide) && isNotUndefined(data)) {
    return [...arr, <CTATile key="cta-tile" data={data} />];
  } else {
    return arr;
  }
};

const shouldAddCTATile = <T,>(
  arr: ReadonlyArray<T>,
  data: CTATileData | undefined,
  itemsPerSlide: number
) => {
  return (
    isNotUndefined(data) && (arr.length > itemsPerSlide || data.alwaysVisible)
  );
};

export const CTATile: React.FC<{ data: CTATileData }> = ({ data }) => {
  return (
    <TileWrapper
      to={data.linkTo}
      onClick={data.onClick}
      data-test-id="cta-tile-wrapper"
    >
      <IconWrapper>
        <Arrow direction="right" fontSize="32px" />
      </IconWrapper>
      <Spacer height="2x" />
      <Typography variant="paragraphSansMedium" align="center">
        {data.text}
      </Typography>
    </TileWrapper>
  );
};

const TileWrapper = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: ${getSpacing("2x")};
`;

const IconWrapper = styled(Row).attrs({
  align: "center",
  justify: "center",
})`
  background: ${Core.surface.tertiary};
  width: ${getSpacing("7x")};
  height: ${getSpacing("7x")};
  border-radius: 50%;
`;
